import type { PageMeta } from './pageMeta'
import { pageMeta as citAccrual } from '../../pages/finance/tax-compliance/CitAccrualPage'
import { pageMeta as pos } from '../../pages/pos/POSPage'
import { pageMeta as users } from '../../pages/settings/UsersPage'
import { pageMeta as sellInvoices } from '../../pages/sell/tabs/SellInvoicesTab'
import { pageMeta as posSessions } from '../../pages/sell/tabs/POSSessionsTab'
import { pageMeta as sellReturns } from '../../pages/sell/tabs/SellReturnsTab'
import { pageMeta as onlineOrders } from '../../pages/sell/tabs/OnlineOrdersTab'
import { pageMeta as buyPurchases } from '../../pages/buy/tabs/BuyPurchasesTab'
import { pageMeta as buyInTransit } from '../../pages/buy/tabs/BuyInTransitTab'
import { pageMeta as buyReturns } from '../../pages/buy/tabs/BuyReturnsTab'
import { pageMeta as paymentsCustomers } from '../../pages/trading/payments/CustomerPaymentsTab'
import { pageMeta as paymentsVendors } from '../../pages/trading/payments/VendorPaymentsTab'
import { pageMeta as paymentsExpenses } from '../../pages/trading/payments/ExpensePaymentsTab'
import { pageMeta as salesPerRep } from '../../pages/trading/sales-rep/SalesPerRepPage'
import { pageMeta as salesPayments } from '../../pages/reports/SalesPaymentReportPage'
import { pageMeta as purchasePayments } from '../../pages/reports/PurchasePaymentReportPage'
import { pageMeta as productPurchases } from '../../pages/reports/ProductPurchaseReportPage'
import { pageMeta as productMovement } from '../../pages/reports/ProductMovementReportPage'
import { pageMeta as incentives } from '../../pages/trading/incentives/IncentivesPage'
import { pageMeta as incentivePayables } from '../../pages/trading/incentive-payables/PayablesPage'

// Virtual dashboard pageKeys — no route of their own, they gate sensitive
// sections within DashboardPage. Sensitive by default: only owner/admin see
// profit & cash figures until a role is explicitly granted access.
const dashboardProfitView: PageMeta = {
  key: 'dashboard.profit_view',
  label: 'Dashboard - Profit/P&L View',
  module: 'Dashboard',
  section: 'Dashboard',
  description: 'Controls visibility of the P&L summary, expense breakdown, and profit indicators',
  isVirtual: true,
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'none',
    accountant: 'none', cashier: 'none', viewer: 'none',
  },
}

const dashboardCashPosition: PageMeta = {
  key: 'dashboard.cash_position',
  label: 'Dashboard - Cash & Bank Position',
  module: 'Dashboard',
  section: 'Dashboard',
  description: 'Controls visibility of cash and bank balance details',
  isVirtual: true,
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'none',
    accountant: 'none', cashier: 'none', viewer: 'none',
  },
}

// Hand-rolled today; in Session 2c this becomes auto-generated by the
// check-page-coverage script so every `export const pageMeta` is included.
export const PAGE_METAS: ReadonlyArray<PageMeta> = [
  citAccrual,
  pos,
  users,
  sellInvoices,
  posSessions,
  sellReturns,
  onlineOrders,
  buyPurchases,
  buyInTransit,
  buyReturns,
  paymentsCustomers,
  paymentsVendors,
  paymentsExpenses,
  salesPerRep,
  salesPayments,
  purchasePayments,
  productPurchases,
  productMovement,
  incentives,
  incentivePayables,
  dashboardProfitView,
  dashboardCashPosition,
]
